// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__qc4Jd","title":"ClientReferral_title__13LZ1","itemText":"ClientReferral_itemText__Izyjl"};